<template>
  <div>
    <h1 class="page-header">{{ $t('studentCardActivator.cardActivator') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              :leave="route_leave"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-6 com-md-9 col-sm-12 d-flex justify-content-start"
              ></div>
              <div
                class="col-lg-6 com-md-3 col-sm-12 d-flex justify-content-end"
              >
                <select
                  class="form-control"
                  v-model.number="status_id"
                  style="width: 120px"
                >
                  <option value disabled selected style="display: none">
                    {{ $t('select') }}
                  </option>
                  <option
                    v-for="(status, index) in cardStatus"
                    :key="index"
                    :value="status.card_status_id"
                  >
                    {{ status.card_status }}
                  </option>
                </select>
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 300px"
                  class="ml-2"
                />
                <ts-button
                  outline
                  class="ml-2"
                  v-tooltip="$t('filter')"
                  @click.prevent="visible = true"
                >
                  <i class="fa fa-filter"></i>
                </ts-button>
              </div>
            </div>
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-table
              :columns="columns"
              :records="resources"
              :loading="loading"
            >
              <template v-slot="{ record }">
                <td class="ts-whitespace-no-wrap">
                  {{ record.branch ? record.branch.branch_name_en : '' }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{
                    record.student_profile
                      ? record.student_profile.card_number
                      : ''
                  }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{
                    record.student_profile
                      ? record.student_profile.full_name_en +
                        '|' +
                        record.student_profile.full_name_kh
                      : ''
                  }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  {{ record.serial_card }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  {{ record.registered_date }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  <span class="label label-success" v-if="record.status_id == 1"
                    >Active</span
                  >
                  <span class="label label-default" v-if="record.status_id == 2"
                    >Inactive</span
                  >
                </td>
                <td class="ts-whitespace-no-wrap">{{ record.reason }}</td>
                <td class="ts-whitespace-no-wrap text-center">
                  <a
                    href="#"
                    v-tooltip="$t('studentCardActivator.changeStatus')"
                    class="text-primary"
                    @click.prevent="change(record)"
                  >
                    <i class="fas fa-random"></i>
                  </a>
                </td>
              </template>
            </ts-table>
          </div>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination
              v-model="pagination"
              @navigate="fetchData"
            ></ts-pagination>
          </ts-card-wrapper>
        </ts-card>
        <!-- drawer -->
        <a-drawer
          :title="$t('invoice.filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="() => (visible = false)"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <a-select
                  style="width: 257px"
                  v-model="branch_id"
                  :options="branchs"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                >
                </a-select>
              </div>
            </div>
          </div>
        </a-drawer>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'
import FormChange from './change.vue'

export default {
  components: {
    FormCreate
  },
  name: 'student-card-activator',
  props: ['editData'],
  data () {
    return {
      edit_data: this.editData,
      loading: false,
      route_leave: false,
      branchs: [],
      visible: false,
      columns: [
        {
          name: this.$t('studentCardActivator.branch')
        },
        {
          name: this.$t('studentCardActivator.cardNumber')
        },
        {
          name: this.$t('studentCardActivator.studentName')
        },
        {
          name: this.$t('studentCardActivator.serialCard'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('studentCardActivator.registerDate'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('studentCardActivator.status'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('studentCardActivator.reason')
        },
        {
          name: this.$t('studentCardActivator.action'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchResourceBeforeCreate()
    this.getBranch()
  },
  computed: {
    ...mapState('studentCardActivator', [
      'resources',
      'pagination',
      'cardStatus'
    ]),
    search: {
      get () {
        return this.$store.state.studentCardActivator.search
      },
      set (newVal) {
        this.$store.commit('studentCardActivator/SET_SEARCH', newVal)
        this.$store.commit('studentCardActivator/RESET_CURRENT_PAGE')
      }
    },
    status_id: {
      get () {
        return this.$store.state.studentCardActivator.status_id
      },
      set (newVal) {
        this.$store.commit('studentCardActivator/SET_STATUS_ID', newVal)
      }
    },
    branch_id: {
      get () {
        return this.$store.state.studentCardActivator.branch_id
      },
      set (newValue) {
        this.$store.commit('studentCardActivator/SET_BRANCH_ID', newValue)
      }
    }
  },
  methods: {
    fetchResourceBeforeCreate () {
      this.$store
        .dispatch('studentCardActivator/dataBeforeCreate')
        .then(() => {
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    fetchData (attributes) {
      this.loading = true

      this.$store
        .dispatch(
          'studentCardActivator/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    change (data) {
      this.$modal.show(
        FormChange,
        {
          data: data
        },
        {
          height: 'auto',
          width: '330px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({
        search,
        branch_id: this.branch_id
      })
    }, 500),
    status_id: debounce(function (val) {
      this.fetchData({ val, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'student-card-activator-create') {
      this.$store.commit('studentCardActivator/RESET_STATE')
      this.$store.commit('studentCardActivator/SET_STUDENTS', [])
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
